
import React from 'react';
// Styles
import StyleWrapper from './Wrapper';

export default class AppInfo extends React.Component {
    render() {
        return (
            <StyleWrapper className="app-info" style={this.props.style}>
                <div className="app-logo-container">
                    <img src={this.props.url}/>
                </div>

                <div className="info-container">
                    <div className="app-name">
                        {this.props.appName}
                    </div>

                    <div className="app-information">
                        {this.props.children}
                    </div>
                </div>
            </StyleWrapper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Headers/AppInfo/index.js